import { SearchInput, Text, Link, Stack } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import styled from '@emotion/styled';

const Content = styled(Stack)`
  width: 100%;
`;

export interface SurveyTemplatesSearchProps {
  searchValue: string;
  onSearchValueChange: (newValue: string) => void;
}

export const SurveyTemplatesSearch = ({
  searchValue,
  onSearchValueChange,
}: SurveyTemplatesSearchProps): JSX.Element => {
  const { t } = useTranslation('survey-templates');

  const triggerSurvey = () => {
    if (window.hj) {
      window.hj('trigger', 'request_template');
    }
  };

  // add 'request a template' here (FBS-734)
  return (
    <Content direction="column" spacing="x2">
      <SearchInput
        value={searchValue}
        name="search"
        placeholder={t('search.placeholder')}
        clearActionProps={{
          description: t('search.clear-description'),
          actionText: t('search.clear-description'),
        }}
        onChange={(event) => {
          onSearchValueChange(event.target.value);
        }}
      />
      <Text textType="body2" textColor="text_light">
        {t('search.no-useful-templates')}&nbsp;
        <Link
          data-testid="request-template-button"
          kind="standalone"
          as="button"
          onClick={() => triggerSurvey()}
        >
          {t('search.request-template')}
        </Link>
      </Text>
    </Content>
  );
};
